import MenuItem, { type MenuItemProps } from '@mui/material/MenuItem';
import type React from 'react';
import { SimpleLink } from '../link/index.js';

type MenuItemLinkProps = MenuItemProps & {
  readonly href: string;
};

const MenuItemLink: React.FC<MenuItemLinkProps> = (props: MenuItemLinkProps): JSX.Element => {
  const { href, ...rest } = props;
  return (
    <SimpleLink href={href}>
      <MenuItem {...rest} />
    </SimpleLink>
  );
};

export default MenuItemLink;
